export const topUserMenu = () => {
    const topUserMenu = document.querySelector('.l-header__account .c-dropdown');


    /*let AOS = require("aos");
    const sensorsTable = document.querySelector('.c-sensors__list .c-data-table')
    const dropdownMenu = document.querySelector('.c-dropdown__menu');

    if (sensorsTable) {
        const allTypes = sensorsTable.querySelectorAll('.c-data-table__row');
        const allSone = sensorsTable.querySelectorAll('.c-sensor-type--sone');
        const allDsw = sensorsTable.querySelectorAll('.c-sensor-type--dsw');

        const hideAll = () => {
            allTypes.forEach((item) => {
                item.classList.add('hide');
            });
        }

        const showType = (type) => {
            if ('c-sensor-type--sone' === type) {
                allSone.forEach((item) => {
                    item.classList.remove('hide');
                });
            }

            if ('c-sensor-type--dsw' === type) {
                allDsw.forEach((item) => {
                    item.classList.remove('hide');
                });
            }

            if ('c-sensor-type--all' === type) {
                allTypes.forEach((item) => {
                    item.classList.remove('hide');
                });
            }
        }

        const setCurrentChoose = (label) => {
            const dropdownButton = document.querySelector('.c-dropdown__button');

            if (dropdownButton) {
                dropdownButton.innerHTML = label;
            }
        }

        if (dropdownMenu) {
            const dropdownItems = dropdownMenu.querySelectorAll('.dropdown-item');

            dropdownItems.forEach((item, index) => {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    const currentType = item['id'];

                    hideAll();
                    showType(currentType);
                    setCurrentChoose(item.innerHTML);
                    AOS.refresh();
                });
            });
        }
    }*/
}
